import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { BreadcrumbsInput, Breadcrumb } from 'models/interfaces';

export const GET_BREADCRUMBS = gql`
  query GetBreadcrumbs($breadcrumbsInput: BreadcrumbsInput) {
    breadcrumbs(breadcrumbsInput: $breadcrumbsInput) {
      name
      url
    }
  }
`;

interface BreadcrumbsContainerProps {
  children: (props: any) => any;
  breadcrumbsInput: BreadcrumbsInput;
}

interface BreadcrumbsQueryResults {
  breadcrumbs: [Breadcrumb];
}

interface BreadcrumbsQueryVariables {
  breadcrumbsInput: BreadcrumbsInput;
}

//class BreadcrumbsQuery extends Query<BreadcrumbsQueryResults, BreadcrumbsQueryVariables> {}

const BreadcrumbsContainer: React.FunctionComponent<BreadcrumbsContainerProps> = ({
  children,
  breadcrumbsInput
}) => {
  return (
    <Query<BreadcrumbsQueryResults, BreadcrumbsQueryVariables>
      query={GET_BREADCRUMBS}
      variables={{ breadcrumbsInput }}
    >
      {({ data: { breadcrumbs } = { breadcrumbs: {} }, loading, error, client }) => {
        return children({
          loading,
          error,
          breadcrumbs,
          updateCache: async (data: any) => {
            await client.writeData({ data });
          },
          client
        });
      }}
    </Query>
  );
};

export default BreadcrumbsContainer;
